'use strict'

const AccessPolicyActions = require('./access-policy-actions')
const BasePolicy = require('../common/policy')
const extend = require('extend')
const Util = require('../common/util')

const defaultVersion = '2018-03-02'

const mergeWithWildcard = (actionsByResource, resource) => {
    return extend(
        true,
        {},
        actionsByResource[resource],
        actionsByResource[Util.Wildcard]
    )
}

class Policy extends BasePolicy {

    constructor(document) {
        super(document, defaultVersion)
    }

    innerFactory(document) {
        return new Policy(document)
    }

    filterThrough(policy) {
        const actionsByResourceStart = this.servicesByResource
        const actionsByResourceEnd = policy.servicesByResource
        const p = new Policy()
        Object.keys(actionsByResourceEnd).forEach(r => {
            // deal with resource hierarchy
            if (!actionsByResourceStart[Util.Wildcard] && !actionsByResourceStart[r]) {
                return
            }
            const servicesStart = mergeWithWildcard(actionsByResourceStart, r)
            const servicesEnd = mergeWithWildcard(actionsByResourceEnd, r)
            Object.keys(servicesEnd).forEach(s => {
                if (!servicesStart[s]) {
                    return
                }
                const activitiesStart = servicesStart[s]
                const activitiesEnd = servicesEnd[s]
                if (activitiesStart[Util.Wildcard]) {
                    Object.keys(activitiesEnd).forEach(a => {
                        p.addAction(s, a, r)
                    })
                }
                else if (activitiesEnd[Util.Wildcard]) {
                    Object.keys(activitiesStart).forEach(a => {
                        p.addAction(s, a, r)
                    })
                }
                else {
                    Object.keys(activitiesEnd).forEach(a => {
                        if (activitiesStart[a]) {
                            p.addAction(s, a, r)
                        }
                    })
                }
            })
        })
        return p
    }

    applyTo(accessPolicy, accessPolicyFactory) {
        const featureActions = Object.keys(this.document.Statement.reduce(
            (map, s) => {
                return s.Action.reduce((m, a) => {
                    map[a] = true
                }, map)
            },
            {}
        )).map(Util.parseAction)
        return AccessPolicyActions.forFeatureActions(featureActions)
            .then(actions => {
                const actionMap = actions.reduce((m, a) => {
                    m[a] = true
                    return m
                }, {})
                return accessPolicy.evaluate()
                    .then(policy => {
                        return policy.enumerateActions().reduce((ap, a) => {
                            // a = { resource, action, effect }
                            // if a is in the full set of access policy actions
                            // append to new access policy
                            if (actionMap[a.action]) {
                                ap.addAction(a)
                            }
                        }, accessPolicyFactory())
                    })
            })
    }

}

module.exports = {
    create(policyJson) {
        return new Policy(policyJson)
    }
}



//////////////////
// WEBPACK FOOTER
// ./~/@gsm/authorizer/lib/feature-policy/policy.js
// module id = 297
// module chunks = 51